import { Pipe, PipeTransform } from '@angular/core';

import { CustomTranslationsService } from '../translations';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateEssSystemType',
})
export class TranslateEssSystemTypePipe implements PipeTransform {
  constructor(
    private customTranslationsService: CustomTranslationsService,
    private translateService: TranslateService
  ) {}
  transform(value: string): string {
    if (value && this.customTranslationsService.ESS_SYSTEM_TYPES[value]) {
      return this.translateService.instant(this.customTranslationsService.ESS_SYSTEM_TYPES[value]);
    }

    return value;
  }
}
